<template lang='pug'>
  div.sc-dashboard
    div.maxSizeCarousel
      ods-row.sc-dashboard__row(type='flex')
        //- Carousel KPIs)
        div(v-if="kpisDataFiltered.length < 1" v-loading="!!!kpisDataFiltered" style="width: 100%; background-color: white; display: flex; align-items: center")
          StatusCero(
            title='no data'
            description='no data kpi dashboard'
            v-if="kpisDataFiltered"
          )
        carousel.carouselKpis(
          v-if="kpisDataFilteredShow"
          :perPage='itemCarousel'
          :paginationEnabled='false'
          :navigationEnabled='true'
          :paginationSize='6'
          :centerMode='true'
          :autoplay='true'
          :autoplayTimeout='3000'
          :paginationPadding='4'
          navigationNextLabel='<i class="ods-icon-carousel-chevron-right"></i>'
          navigationPrevLabel='<i class="ods-icon-carousel-chevron-left"></i>'
        )
          template(v-for='(item, index) in kpisDataFiltered')
            slide(v-if='item.measureType')
              transition(name='slide-fade-up' appear mode="out-in")
                div(:class='item.entityType === carouselSelected ? "VueCarousel-slide-selected" : ""')
                  ods-row.sc-kpi__row(
                    type='flex'
                    :gutter='16'
                    @click.native='showCarouselDetail(item)'
                    )
                    ods-col.sc-kpi__col(
                      :span='24'
                    )
                      div.sc-kpi__title
                        //- div.custom-icon
                        //-   i(:class='mapModuleClmIcon(item.type)')
                        span.kpi-unit {{ $t(item.measureType) }} - 8
                    ods-col.sc-kpi__col(
                      :span='12'
                    )
                      ods-kpi(v-if='item.kpiMaxValue' :unit='$t(item.kpiUnit)' :ammount='formatLocaleNumber(Number(item.kpiMaxValue))' :percentage='(item.kpiTrendMaxValue === "UP" ? 1 : (item.kpiTrendMaxValue === "down" ? -1 : null))' triangle='')
                        span(slot='title') {{ $t('maximum') }}
                          p.percentageNull(v-if='(item.kpiTrendMaxValue === undefined)') =
                      KpiDefault(v-else
                        type='maximum'
                      )
                    ods-col.sc-kpi__col(
                      :span='12'
                    )
                      ods-kpi(v-if='item.kpiMinValue' :unit='$t(item.kpiUnit)' :ammount='formatLocaleNumber(Number(item.kpiMinValue))' :percentage='(item.kpiTrendMinValue === "UP" ? 1 : (item.kpiTrendMinValue === "down" ? -1 : null))' triangle='')
                        span(slot='title') {{ $t('minimum') }}
                          p.percentageNull(v-if='(item.kpiTrendMinValue === undefined)') =
                        //- span.sc-kpi_arrow
                        //-   icon-svg(:icon='arrow')
                      KpiDefault(v-else
                        type='minimum'
                      )
                    ods-tooltip.item(effect='dark' placement='left')
                      div.sc-kpi__tooltip(slot="content") {{ $t(item.entityType) }}
                      ods-icon.sc-kpi__icon.sc-kpi__icon--info(name="info" size="20")
                    ods-icon.sc-kpi__icon.sc-kpi__icon--arrow(name="chart-line" size="20")
    div.maxSizeRow2
      ods-row.sc-dashboard__row.cardsBottom(type='flex' :gutter='16' )
        //- Alerts
        ods-col.sc-dashboard__col(:xs='24' :sm='12' :md='8' v-if="!showAlert")
          div(style="height: calc(50% - 8px")
            Card(size='small' :scrollbar='false' :loading='!!!alertsTodayFiltered && !!!alertsWeekFiltered').sc-dashboard__alert
              template(slot='header')
                div.card-title {{ $t('alerts') }}
                div
                  ods-select(
                    multiple
                    collapse-tags
                    v-model='alertsCurrentFilter'
                    placeholder='Select'
                    @change='moduleAlertChange'
                    size="hecto"
                  )
                    ods-option(
                      v-for='item in alertsFilters'
                      :key='item.value'
                      :label='$t(item.label)'
                      :value='item.value'
                    )
                  // ods-button(type='secondary' size='small' @click="showAlert = !showAlert") ver Campañas
              div(v-if='alertsShow')
                ods-tabs(v-model='alertsTab' @tab-click='handleTabs' style="height: 100%")
                  ods-tab-pane.h100(name='first')
                    div(slot='label' :alertsTodayFiltered="alertsTodayFiltered") {{ $t('today') }}
                      span.card-counter(v-if="alertsTodayFiltered") {{ alertsTodayFiltered.length }}
                      span.card-counter(v-else) 0
                    template(v-if='alertsTodayFiltered && !alertsTodayFiltered.length')
                      StatusCero(
                        title='no data'
                        description='no data alerts today'
                      )
                    //- ods-scrollbar(v-else wrap-class='ods-scrollbar__wrap')
                      div.maxSizeCard(v-model='campaignTab')
                    AlertsAndCampaignList(
                      v-else
                      height='calc(100vh - 373px)'
                      alert
                      link
                      :dataTable='alertsTodayFiltered'
                      @detailSelect='showAlertsDetail'
                    )
                  ods-tab-pane.h100(label='Últimos 7 días' name='second')
                    div(slot='label') {{ $t('last 7 days') }}
                      span.card-counter(v-if="alertsWeekFiltered") {{  alertsWeekFiltered.length }}
                      span.card-counter(v-else) 0
                    template(v-if='alertsWeekFiltered && !alertsWeekFiltered.length')
                      StatusCero(
                        title='no data'
                        description='no data alerts week'
                      )
                    //- ods-scrollbar(v-else wrap-class='ods-scrollbar__wrap')
                      div.maxSizeCard(v-model='campaignTab')
                    AlertsAndCampaignList(
                      v-else
                      height='calc(100vh - 373px)'
                      alert
                      link
                      :dataTable='alertsWeekFiltered'
                      @detailSelect='showAlertsDetail'
                    )
          div(style="height: calc(50% - 8px; margin-top: 16px;")
            Card(size='small' :scrollbar='false' :loading='!!!campaignsActivesFiltered && !!!campaignsInactivesFiltered').sc-dashboard__campanigns
              template(slot='header')
                div.card-title {{ $t('campaigns') }}
                div
                  ods-select(
                    multiple
                    collapse-tags
                    v-model='campaignCurrentFilter'
                    placeholder='Select'
                    @change="moduleCampaignChange"
                  )
                    ods-option(
                      v-for='item in campaignFilters'
                      :key='item.value'
                      :label='$t(item.label)'
                      :value='item.value'
                    )
                  // ods-button(type='secondary' size='small' @click="showAlert = !showAlert") Ver alertas
              div(v-if='campaignShow')
                ods-tabs(v-model='campaignTab' @tab-click='handleTabs' style="height: 100%")
                  ods-tab-pane.h100(name='first')
                    div(slot='label') {{ $t('actives') }}
                      span.card-counter(v-if="campaignsActivesFiltered") {{campaignsActivesFiltered.length}}
                      span.card-counter(v-else)
                    template(v-if='campaignsActivesFiltered && !campaignsActivesFiltered.length')
                      StatusCero(
                        title='no data'
                        description='no data campaign active'
                      )
                    //- ods-scrollbar(v-else wrap-class='ods-scrollbar__wrap')
                      div.maxSizeCard(v-model='campaignTab')
                    AlertsAndCampaignList(
                      link
                      height='calc(100vh - 373px)'
                      campaign
                      :dataTable='campaignsActivesFiltered'
                      @detailSelect='showCampaignDetail'
                    )
                  ods-tab-pane.h100(label='Inactivas' name='second')
                    div(slot='label') {{ $t('inactives') }}
                      span.card-counter(v-if="campaignsInactivesFiltered") {{campaignsInactivesFiltered.length}}
                      span.card-counter(v-else) 0
                    template(v-if='campaignsInactivesFiltered && !campaignsInactivesFiltered.length')
                      StatusCero(
                        title='no data'
                        description='no data campaign inactive'
                      )
                    //- ods-scrollbar(v-else wrap-class='ods-scrollbar__wrap')
                      div.maxSizeCard(v-model='campaignTab')
                    AlertsAndCampaignList(
                      link
                      height='calc(100vh - 373px)'
                      campaign
                      :dataTable='campaignsInactivesFiltered'
                      @detailSelect='showCampaignDetail'
                    )
        //- End Alerts
        //- Campaign
        ods-col.sc-dashboard__col(:xs='24' :sm='12' :md='8' v-if="showAlert")
          Card(size='small' :scrollbar='false' :loading='!!!campaignsActivesFiltered && !!!campaignsInactivesFiltered').sc-dashboard__campanigns
            template(slot='header')
              div.card-title {{ $t('campaigns') }}
              div
                ods-select(
                  multiple
                  collapse-tags
                  v-model='campaignCurrentFilter'
                  placeholder='Select'
                  @change="moduleCampaignChange"
                )
                  ods-option(
                    v-for='item in campaignFilters'
                    :key='item.value'
                    :label='$t(item.label)'
                    :value='item.value'
                  )
                // ods-button(type='secondary' size='small' @click="showAlert = !showAlert") Ver alertas
            div(v-if='campaignShow')
              ods-tabs(v-model='campaignTab' @tab-click='handleTabs')
                ods-tab-pane.h100(name='first')
                  div(slot='label') {{ $t('actives') }}
                    span.card-counter(v-if="campaignsActivesFiltered") {{campaignsActivesFiltered.length}}
                    span.card-counter(v-else)
                  template(v-if='campaignsActivesFiltered && !campaignsActivesFiltered.length')
                    StatusCero(
                      title='no data'
                      description='no data campaign active'
                    )
                  //- ods-scrollbar(v-else wrap-class='ods-scrollbar__wrap')
                    div.maxSizeCard(v-model='campaignTab')
                  AlertsAndCampaignList(
                    link
                    height='calc(100vh - 373px)'
                    campaign
                    :dataTable='campaignsActivesFiltered'
                    @detailSelect='showCampaignDetail'
                  )
                ods-tab-pane.h100(label='Inactivas' name='second')
                  div(slot='label') {{ $t('inactives') }}
                    span.card-counter(v-if="campaignsInactivesFiltered") {{campaignsInactivesFiltered.length}}
                    span.card-counter(v-else) 0
                  template(v-if='campaignsInactivesFiltered && !campaignsInactivesFiltered.length')
                    StatusCero(
                      title='no data'
                      description='no data campaign inactive'
                    )
                  //- ods-scrollbar(v-else wrap-class='ods-scrollbar__wrap')
                    div.maxSizeCard(v-model='campaignTab')
                  AlertsAndCampaignList(
                    link
                    height='calc(100vh - 373px)'
                    campaign
                    :dataTable='campaignsInactivesFiltered'
                    @detailSelect='showCampaignDetail'
                  )
        //- End Campaign
        //- Point of interest
        ods-col.sc-dashboard__col(:xs='24' :sm='12' :md='8')
          Card(size='small' :scrollbar='false' :loading='!!!campaignsActivesFiltered && !!!campaignsInactivesFiltered').sc-dashboard__centralidad
            template(slot='header')
              div.card-title {{ $t('centralidadfuncional') }}
            div
              ods-scrollbar(viewClass="view-class" wrapClass="wrap-class-canvas")
                ods-select(
                  size="hecto"
                  multiple=true
                  collapse-tags
                  v-model='filterRadarSelected'
                  placeholder='Select'
                  @change='updateFilterRadarSub'
                )
                  ods-option(
                    v-for='item in filterRadar'
                    :key='item.value'
                    :label='$t(item.label)'
                    :value='item.value'
                  )
                ods-select(
                  style="margin-left: 8px"
                  size="hecto"
                  multiple
                  collapse-tags
                  v-model='filterRadarSubSelected'
                  placeholder='Select'
                  @change='updateFilterRadarSub'
                )
                  ods-option(
                    v-for='item in filterRadarSub'
                    :key='item.data'
                    :label='$t(item.label)'
                    :value='item.data'
                  )
                div.boxRadarGraph(style="height; 100%;margin: 50px 0;")
                  canvas(id='radarGraph' class='radarGraph'
                  style="display: block; width: 450px; height: 350px")
                //- fullscreen(ref="fullscreen" @change="fullscreenChange")
                //-   p Contenido
                //- button(type="button" @click="toggle") Zoom
        //- End Point or Interest
        //- Social network
        ods-col.sc-dashboard__col(:xs='24' :sm='12' :md='8')
          Card(size='small' :scrollbar='false' :loading='!!!socialNetworksDataFiltered').sc-dashboard__social
            template(slot='header')
              div.card-title {{ $t('social networks') }}
              div
                ods-select.selectSocial(
                  v-model='socialNetworkCurrentFilter'
                  placeholder='Select'
                  @change="moduleSocialNetWorkChange"
                )
                  ods-option(
                    v-for='item in socialNetworkFilters'
                    :key='item.value'
                    :label='$t(item.label)'
                    :value='item.value'
                  )
            ods-tabs(v-model='activeTab' @tab-click='handleTabs')
              ods-tab-pane.h100(label='timeline' name='first')
                div(slot='label') {{ $t('timeline') }}
                template(v-if='socialNetworksDataFiltered && !socialNetworksDataFiltered.length')
                  StatusCero(
                    title='no data'
                    description='no data social timeline'
                  )
                ods-scrollbar(v-else wrap-class='ods-scrollbar__wrap')
                  div.maxSizeSocialCard
                    SocialCard(
                      :data='item'
                      v-for='(item, index) in socialNetworksDataFiltered'
                      :key='index'
                    )
              //- ods-tab-pane.h100(label='trends' name='second')
              //-   div(slot='label') {{ $t('trends') }}
              //-   template
              //-     StatusCero(
              //-       title='no data'
              //-       description='no data social trends'
              //-     )
        //- End Social network
      //- Alerts Modal
    ods-dialog(
      v-if='alertsModalData'
      :visible.sync='alertsModal'
      width='95%'
      :append-to-body='true'
      custom-class='sc-modal'
    )
      div.sc-modal__header__content
        div.sc-modal__title {{ alertsModalData.name }}
        div.sc-modal__header
          div.sc-modal__intro {{ $t('alert') }} - {{ $t(alertsModalData.clmmodule) }}
          div.sc-modal__meta
            div.table-dot(v-if="alertsModalData.level === 'high'" class="table-dot--danger")
            div.table-dot(v-if="alertsModalData.level === 'medium'" class="table-dot--medium")
            div.table-dot(v-if="alertsModalData.level === 'low'" class="table-dot--warning")
            div.sc-modal__intro.ods-ml-2 {{ $t('nivel') }} {{ $t(alertsModalData.level) }}
        div.sc-modal__subtitle
        ods-scrollbar(wrap-class='ods-scrollbar__wrap')
          div.sc-modal__description {{ alertsModalData.description }}
        div.sc-modal__link
      div.sc-modal__body
        ods-row.sc-dashboard__row(type='flex' :gutter='16')
          ods-col(:span='5')
            div.sc-modal__box
              div.sc-modal__label {{ $t('hour') }}
              div.sc-modal__data {{ formatLocaleHour(alertsModalData.date) }}
          ods-col(:span='6')
            div.sc-modal__box
              div.sc-modal__label {{ $t('date') }}
              div.sc-modal__data {{ formatLocaleDate(alertsModalData.date) }}
          ods-col(:span='8' v-if="alertsModalData.address")
            div.sc-modal__box
              div.sc-modal__label {{ $t('location') }}
              div.sc-modal__data {{ alertsModalData.address }}
    //- End Alerts Modal
    //- Campaign Modal
    ods-dialog(
      v-if = 'campaignsModalData'
      :visible.sync='campaignModal'
      width='95%'
      :append-to-body='true'
      custom-class='sc-modal'
    )
      div.sc-modal__header__content
        div.sc-modal__title {{ campaignsModalData.name }}
        div.sc-modal__header
          div.sc-modal__intro {{ $t('campaign') }} - {{ $t(campaignsModalData.type) }}
        ods-row.sc-dashboard__row(type='flex')
          div.sc-modal__meta
            ods-select.selectSocial(
              v-model='levelCurrentFilter'
              placeholder='Select'
            )
              ods-option(
                v-for='item in modalLevelFilters'
                :key='item.value'
                :label='$t(item.label)'
                :value='item.value'
              )
            ods-select.selectSocial(
              v-model='stateCurrentFilter'
              placeholder='Select'
            )
              ods-option(
                v-for='item in modalStateFilters'
                :key='item.value'
                :label='$t(item.label)'
                :value='item.value'
              )
            ods-button(type='secondary' size='small' round @click.native='updateStateLevelCampaign') {{ $t('Actualizar') }}
        div.sc-modal__subtitle
        ods-scrollbar(wrap-class='ods-scrollbar__wrap')
          div.sc-modal__description {{ campaignsModalData.description }}
        div.sc-modal__body
          ods-row.sc-dashboard__row(type='flex')
            ods-col(:span='8')
              div.sc-modal__box
                div.sc-modal__label {{ $t('startDate') }}
                div.sc-modal__data {{ formatLocaleDate(campaignsModalData.startDate) }}
            ods-col(:span='8')
              div.sc-modal__box
                div.sc-modal__label {{ $t('endDate') }}
                div.sc-modal__data {{ formatLocaleDate(campaignsModalData.endDate) }}
            ods-col(:span='8')
              div.sc-modal__box
                div.sc-modal__label {{ $t('location') }}
                div.sc-modal__data Las Palmas
        div.sc-modal__procedure
          div.sc-modal__title {{ $t('Lanzar procedimiento según nivel') }}
          p {{ $t('Desde aqui puedes lanzar los procedimientos asociados al nivel de esta campaña sin tener que modificar su actual nivel.') }}
          ods-row.sc-dashboard__row(type='flex')
            div.sc-modal__meta
              ods-select.selectSocial(
                v-model='levelProcedureCurrentFilter'
                placeholder='Select'
              )
                ods-option(
                  v-for='item in campaignsModalData.levelProcedure'
                  :key='item.order'
                  :label='$t(item.name)'
                  :value='item.name'
                )
              ods-button(type='secondary' size='small' round @click.native='updateLevelProcedureCampaign') {{ $t('Throw') }}
    //- End Campaign Modal
    //- Chart Modal
    ChartModal(:loading='datosLoader' :title='titleChartModal' :unit='unitChartModal' :data='datosChart')
</template>

<script>
// import moment from 'moment'
import Card from '@/components/Card'
import ChartJS from 'chart.js'
import Timeline from '@/components/Timeline'
import SocialCard from '@/components/SocialCard'
import StatusCero from '@/components/StatusCero'
import KpiDefault from '@/components/KpiDefault'
import AlertsAndCampaignList from '@/components/AlertsAndCampaignList'
import mapElements from '@/mixins/mapElements'
import mapChartsElements from '@/mixins/mapChartsElements'
import { Carousel, Slide } from 'vue-carousel'
import IconSvg from '@/components/IconSvg'
import Chart from '@/components/Chart'
import ChartModal from '@/components/ChartModal'

import jsonKpi from '@/moks/las_palmas/dashboard/kpis'
// import jsonChartKpi from '@/moks/las_palmas/dashboard/chartKpis'
import jsonAlertsList from '@/moks/las_palmas/dashboard/alertsList'
import jsonAlertsListWeek from '@/moks/las_palmas/dashboard/alertsListWeek'
import jsonCampaniasList from '@/moks/las_palmas/dashboard/campaniasList'
import jsonRedesSociales from '@/moks/las_palmas/dashboard/redesSociales'
import districtPoisGraphs from '@/moks/las_palmas/dashboard/districtPoisGraphs'

export default {
  name: 'Dashboard',
  data () {
    return {
      showAlert: false,
      chartsData: null,
      datosChart: null,
      windowWidth: 0,
      campaignModal: false,
      alertsModal: false,
      alertsCurrentFilter: ['1'],
      campaignCurrentFilter: ['1'],
      levelProcedureCurrentFilter: null,
      levelCurrentFilter: 0,
      stateCurrentFilter: 0,
      kpisCurrentFilter: 'all',
      socialNetworkCurrentFilter: 'twitter',
      kpiSelect: 'all',
      itemCarousel: null,
      socialNetworkFilters: [{
        value: '1',
        label: 'All'
      }, {
        value: 'twitter',
        label: 'Twitter'
      }, {
        value: 'instagram',
        label: 'Instagram'
      }],
      modalLevelFilters: [{
        value: '0',
        label: 'Nivel 0'
      }, {
        value: '1',
        label: 'Nivel 1'
      }, {
        value: '2',
        label: 'Nivel 2'
      }, {
        value: '3',
        label: 'Nivel 3'
      }],
      modalStateFilters: [{
        value: 'activo',
        label: 'Activa'
      }, {
        value: 'inactivo',
        label: 'Inactiva'
      }],
      alertsFilters: [{
        value: '1',
        label: 'All'
      }, {
        value: 'environment',
        label: 'Environment and Metereology'
      }, {
        value: 'mobility',
        label: 'mobilityAndTransportation'
      }, {
        value: 'parksandgardens',
        label: 'parksAndGardens'
      }, {
        value: 'fleet',
        label: 'Frotas'
      }, {
        value: 'crm',
        label: 'CRM'
      }],
      campaignFilters: [{
        value: '1',
        label: 'All'
      }, {
        value: 'environment',
        label: 'Environment and Metereology'
      }, {
        value: 'mobility',
        label: 'mobilityAndTransportation'
      }, {
        value: 'parksandgarderns',
        label: 'parksAndGardens'
      }],
      value: '',
      datePicker: null,
      activeTab: 'first',
      campaignTab: 'first',
      alertsTab: 'first',
      alertsToday: undefined,
      alertsTodayFiltered: undefined,
      alertsWeek: undefined,
      alertsWeekFiltered: undefined,
      alertsModalData: null,
      campaignsActives: undefined,
      campaignsActivesFiltered: undefined,
      campaignsInactives: undefined,
      campaignsInactivesFiltered: undefined,
      campaignsModalData: null,
      socialNetworksData: undefined,
      socialNetworksDataFiltered: undefined,
      kpisData: [],
      kpisDataFiltered: undefined,
      kpisDataFilteredShow: false,
      alertsShow: true,
      campaignShow: true,
      loadingKpis: false,
      contKpis: 0,
      chartModalData: null,
      chartModal: false,
      carouselSelected: null,
      titleChartModal: null,
      unitChartModal: null,
      kpiSlideSelected: null,
      datosLoader: false,
      filterRadar: [],
      filterRadarSelected: [],
      filterRadarSub: [],
      filterRadarSubSelected: [],
      jsonFilterRadar: null,
      objradarGraph: null
    }
  },
  mixins: [ mapElements, mapChartsElements ],
  computed: {
    getLangData () {
      return this.$store.getters.getLang
    },
    isToday () {
      if (this.datePicker) {
        let today = new Date()
        let isToday = (today.toDateString() === this.datePicker.toDateString())
        return isToday
      } else {
        return true
      }
    },
    getCalendarData () {
      return this.$store.getters.getCalendarData
    },
    getCampainDetailData () {
      return this.$store.getters.getCampainDetailData
    },
    getSocialNetworksData () {
      return this.$store.getters.getSocialNetworksData
    }
  },
  watch: {
    getSocialNetworksData (val) {
      const component = this
      if (val) {
        component.socialNetworksData = []
        component.socialNetworksData = component.mapList(val, 'social')
        component.socialNetworksDataFiltered = [...component.socialNetworksData]
      }
    },
    getLangData () {
      this.getPoisGraphData()
    }
  },
  methods: {
    getKpisData () {
      const component = this

      jsonKpi.forEach(element => {
        element.from = this.setTimeRandom(false)
        element.to = new Date(element.from.setDate(element.from.getDate() + 1))
      })

      for (let prop in jsonKpi) {
        component.kpisData.push(jsonKpi[prop])
        component.kpisDataFiltered = [...component.kpisData]
        // console.log('kpisDataFiltered', component.kpisDataFiltered)
      }
      setTimeout(() => {
        this.kpisDataFilteredShow = true
      }, 1000)
    },
    rerender (callback) {
      this.$nextTick(() => {
        callback()
      })
    },
    handleTabs () {
    },
    init () {
      this.initAlerts()
      this.initCampaign()
      this.getKpisData()
      this.initSocialNetworks()
    },
    initDate () {
      const today = new Date()
      this.$store.dispatch('updateCalendar', today.toISOString())
    },
    initAlerts () {
      let val = jsonAlertsList
      let valWeek = jsonAlertsListWeek
      const component = this

      // Alertas de hoy
      jsonAlertsList.forEach(element => {
        element.timestamp = this.setTimeRandom(false)
        element.timestampClose = new Date(element.timestamp.setDate(element.timestamp.getDate() + 1))
      })
      component.alertsToday = []
      component.alertsToday = component.mapList(val, 'alert')
      component.alertsTodayFiltered = [...component.alertsToday]

      // Alertas de última semana
      jsonAlertsListWeek.forEach(element => {
        element.timestamp = this.setTimeRandom(true)
        element.timestampClose = new Date(element.timestamp.setDate(element.timestamp.getDate() + 1))
      })
      component.alertsWeek = []
      component.alertsWeek = component.mapList(valWeek, 'alert')
      component.alertsWeekFiltered = [...component.alertsWeek]

      component.alertsShow = false
      component.rerender(() => {
        component.alertsShow = true
      })
    },

    // Genera fechas con horas aleatorias
    setTimeRandom (weekFlag) {
      const randomDate = new Date()
      const currentHour = !weekFlag ? randomDate.getHours() : 23
      let day = randomDate.getDate()
      let hour = 0 + Math.random() * (currentHour - 0) | 0
      let minutes = 0 + Math.random() * (60 - 0) | 0

      randomDate.setHours(hour)
      randomDate.setMinutes(minutes)
      randomDate.setDate(day - 1)
      if (weekFlag) {
        let countDay = Math.floor(Math.random() * 7) + 1
        randomDate.setDate(randomDate.getDate() - countDay)
      }

      return randomDate
    },

    initCampaign () {
      const component = this
      component.campaignsActives = []

      component.campaignsActives = component.mapList(jsonCampaniasList.active, 'campaign')
      component.campaignsActives.forEach(element => {
        element.startDate = this.setTimeRandom(false)
        let num = Math.round(Math.random() * (5 - 1) + 1)
        element.endDate = new Date()
        element.endDate.setDate(element.startDate.getDate() + num)
        element.period = component.formatLocaleDate(element.startDate) + ' -  ' + component.formatLocaleDate(element.endDate)
      })

      component.campaignsActivesFiltered = [...component.campaignsActives]
      component.campaignsInactives = []
      component.campaignsInactives = component.mapList(jsonCampaniasList.inactive, 'campaign')
      component.campaignsInactives.forEach(element => {
        element.startDate = this.setTimeRandom(false)
        let num = Math.round(Math.random() * (3 - 1) + 1)
        element.endDate = new Date()
        element.endDate.setDate(element.startDate.getDate() + num)
        element.period = component.formatLocaleDate(element.startDate) + ' -  ' + component.formatLocaleDate(element.endDate)
      })
      component.campaignsInactivesFiltered = [...component.campaignsInactives]
      component.campaignShow = false
      component.rerender(() => {
        component.campaignShow = true
      })
    },
    initSocialNetworks () {
      const component = this
      jsonRedesSociales.forEach(element => {
        element.date = this.setTimeRandom(false)
      })
      component.socialNetworksData = []
      component.socialNetworksData = component.mapList(jsonRedesSociales, 'social')
      component.socialNetworksDataFiltered = [...component.socialNetworksData]
    },
    getWindowWidth (event) {
      const component = this
      this.windowWidth = document.documentElement.clientWidth
      if (this.windowWidth >= 1200 && component.itemCarousel !== 4) {
        component.itemCarousel = 4
      } else if (this.windowWidth >= 768 && this.windowWidth < 1200 && component.itemCarousel !== 3) {
        component.itemCarousel = 3
      } else {
        if (component.itemCarousel !== 1 && this.windowWidth < 768) {
          component.itemCarousel = 1
        }
      }
    },
    getWindowHeight (event) {
      this.windowHeight = document.documentElement.clientHeight
    },
    goToday () {
      this.datePicker = new Date()
      this.initDate()
    },
    showAlertsDetail (data) {
      this.alertsModalData = data.list.find(item => {
        return item.id === data.selected.id
      })
      this.alertsModal = true
    },
    showCampaignDetail (data) {
      this.campaignsModalData = data.list.find(item => {
        return item.id === data.selected.id
      })
      this.levelCurrentFilter = this.$t('Nivel ' + this.campaignsModalData.level)
      this.stateCurrentFilter = this.$t(this.campaignsModalData.state)
      this.campaignModal = true
      // console.log(this.campaignsModalData)
    },
    showCarouselDetail (data) {
      const component = this
      let objKpis = {
        labels: [],
        series: []
      }
      component.datosLoader = false
      component.titleChartModal = data.measureType ? data.measureType : 'tipo'
      component.unitChartModal = data.kpiUnit ? data.kpiUnit : 'unidad'
      component.chartModal = true
      component.kpiSlideSelected = data

      var type = data.entityType
      if (type === 'IncidenceObserved') {
        type = 'Incidence'
      }
      if (type === 'CO2AbsorptionObserved') {
        type = 'CO2Absorption'
      }
      component.datosChart = null
      // let inData = {
      //   chartType: type ? type.toUpperCase() : 'GROUND',
      //   timeInterval: component.mapChartIntervalIntro('12m'),
      //   stationId: 'city'
      // }
      let objValues = []
      let objLabel = []
      for (let i = 1; i <= 7; i++) {
        objLabel.push(this.setTimeMock(true, i))
        let value = Math.random() * (component.kpiSlideSelected.kpiMaxValue - component.kpiSlideSelected.kpiMinValue) | component.kpiSlideSelected.kpiMinValue
        value = value.toString()
        objValues.push({
          value: value,
          meta: 'titulo'
        })
      }
      objKpis.series.push(objValues)
      // eslint-disable-next-line
      for (let item of objLabel) {
        let month = item.getMonth() + 1
        let year = item.getFullYear()
        let day = item.getDate()
        item = `${day}/${month}/${year}`
        objKpis.labels.push(item)
      }
      component.datosChart = objKpis
      component.datosLoader = true
    },
    updateChartData (val) {
      // const component = this
    },
    // shortenDescription (row, column, cellValue, index) {
    //   if (cellValue.length > 80) {
    //     return cellValue.substring(0, 80) + '...'
    //   } else {
    //     return cellValue
    //   }
    // },
    // dateChanged (value) {
    //   if (value) {
    //     let date = moment(value).format('YYYY-MM-DD[T]HH:mm:ss.SSSZZ')
    //     this.$store.dispatch('updateCalendar', date)
    //   } else {
    //     this.initDate()
    //   }
    // },
    moduleAlertChange (value) {
      const component = this
      component.alertsTodayFiltered = component.mapFilterList(component.alertsToday, value, 'clmmodule')
      component.alertsWeekFiltered = component.mapFilterList(component.alertsWeek, value, 'clmmodule')
      // rerender tabs alerts value
      component.alertsShow = false
      component.rerender(() => {
        component.alertsShow = true
      })
    },
    moduleCampaignChange (value) {
      const component = this
      component.campaignsActivesFiltered = component.mapFilterList(component.campaignsActives, value, 'clmmodule')
      component.campaignsInactivesFiltered = component.mapFilterList(component.campaignsInactives, value, 'clmmodule')
      // rerender tabs campaign value
      component.campaignShow = false
      component.rerender(() => {
        component.campaignShow = true
      })
    },
    moduleSocialNetWorkChange (value) {
      const component = this
      component.socialNetworksDataFiltered = component.mapFilterList(component.socialNetworksData, value, 'socialNetwork')
    },
    updateStateLevelCampaign (value) {
      const component = this
      let inData = {
        id: component.campaignsModalData.id,
        level: component.levelCurrentFilter,
        state: component.stateCurrentFilter
      }
      component.$store.dispatch('updateLevelStateCampaign', inData)
      setTimeout(function () {
        component.initCampaign()
        component.$notify({
          title: 'Campaña actualizada',
          message: 'Se ha actualizado con éxito la campaña',
          type: 'success',
          customClass: ''
        })
      }, 100)
    },
    updateLevelProcedureCampaign (value) {
      let inData = {
        id: this.campaignsModalData.id,
        level: this.levelProcedureCurrentFilter
      }
      this.$store.dispatch('updateLevelProcedureCampaign', inData)
    },
    getPoisGraphData () {
      const component = this
      component.jsonFilterRadar = districtPoisGraphs.jsonFilterRadar

      // NUEVO
      this.filterRadarSelected = []
      for (const objeto in component.jsonFilterRadar) {
        this.filterRadarSelected.push(objeto)
        this.filterRadar.push({
          value: objeto,
          label: component.jsonFilterRadar[objeto].label
        })
      }
      this.initFilterRadarSub()
    },
    initFilterRadarSub () {
      const vm = this
      vm.filterRadarSubSelected = []
      vm.labelsToRadarGraph = []
      vm.filterRadarSub = []
      let dataObject = {
        data: null,
        value: null,
        label: null
      }
      vm.filterRadarSelected.forEach(district => {
        Object.keys(vm.jsonFilterRadar[district]).forEach((category, i) => {
          if (category !== 'label') {
            dataObject.label = vm.$t(vm.jsonFilterRadar[district][category].label)
            // dataObject.data = vm.jsonFilterRadar[district].label + ' - ' + vm.jsonFilterRadar[district][category].label
            dataObject.data = vm.$t(vm.jsonFilterRadar[district][category].label)
            dataObject.value = 0

            // Preselecciona los valores del combo de categorias
            let elem = vm.filterRadarSubSelected.filter(elem => elem === dataObject.data)
            if (elem.length === 0) {
              vm.filterRadarSubSelected.push(dataObject.data)
              vm.labelsToRadarGraph.push(dataObject.label)
            }
            // Añade valores a la variable que se cargará en el combo
            var actual = vm.filterRadarSub.find(elem => elem.label === dataObject.label)
            if (typeof actual === 'undefined') {
              vm.filterRadarSub.push({
                value: dataObject.label,
                label: dataObject.label,
                data: dataObject.data
              })
            }
          }
        })
      })
      this.updateFilterRadarSub()
    },
    updateFilterRadarSub () {
      // const vm = this
      let myData = {
        labels: [],
        datasets: []
      }
      const colores = [
        {
          backgroundColor: 'rgba(140, 202, 97, 0)',
          borderColor: 'rgb(140, 202, 97)',
          pointBackgroundColor: 'rgb(140, 202, 97)',
          pointHoverBorderColor: 'rgb(140, 202, 97)'
        },
        {
          backgroundColor: 'rgba(3, 69, 136, 0)',
          borderColor: 'rgb(3, 69, 136)',
          pointBackgroundColor: 'rgb(3, 69, 136)',
          pointHoverBorderColor: 'rgb(3, 69, 136)'
        },
        {
          backgroundColor: 'rgba(252, 107, 00, 0)',
          borderColor: 'rgb(252, 107, 00)',
          pointBackgroundColor: 'rgb(252, 107, 00)',
          pointHoverBorderColor: 'rgb(252, 107, 00)'
        },
        {
          backgroundColor: 'rgba(141, 4, 100, 0)',
          borderColor: 'rgb(141, 4, 100)',
          pointBackgroundColor: 'rgb(141, 4, 100)',
          pointHoverBorderColor: 'rgb(141, 4, 100)'
        },
        {
          backgroundColor: 'rgba(25, 159, 27, 0)',
          borderColor: 'rgb(25, 159, 27)',
          pointBackgroundColor: 'rgb(25, 159, 27)',
          pointHoverBorderColor: 'rgb(25, 159, 27)'
        },
        {
          backgroundColor: 'rgba(0, 0, 0, 0)',
          borderColor: 'rgb(0, 0, 0)',
          pointBackgroundColor: 'rgb(0, 0, 0)',
          pointHoverBorderColor: 'rgb(0, 0, 0)'
        }
      ]
      myData.labels = this.filterRadarSubSelected
      this.filterRadarSelected.forEach((district, i) => {
        let dataGraph = []
        let valuesSum = 0

        Object.keys(this.jsonFilterRadar[district]).forEach((category, i) => {
          if (category !== 'label') {
            valuesSum = 0

            this.jsonFilterRadar[district][category].subcategory.forEach(subcategory => {
              valuesSum += subcategory.value
            })

            dataGraph.push(valuesSum)
          }
        })
        for (let i = 0; i < myData.labels.length; i++) {
          if (dataGraph.length < myData.labels.length) dataGraph.push(0)
        }

        // let elem = this.jsonFilterRadar[district][categorySeparator[1]].subcategory.filter(e => e.label === categorySeparator[1]).map(e => { return e.data }).join()
        // if (elem.length > 0) {
        //   dataGraph.push(elem)
        // }

        myData.datasets.push(
          {
            label: this.jsonFilterRadar[district].label,
            data: dataGraph,
            fill: true,
            backgroundColor: colores[i].backgroundColor,
            borderColor: colores[i].borderColor,
            pointBackgroundColor: colores[i].pointBackgroundColor,
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '0#fff',
            pointHoverBorderColor: colores[i].pointHoverBorderColor
          }
        )
      })

      const objChart = {
        type: 'radar',
        data: myData,
        options: {
          legend: {
            display: true,
            position: 'top',
            align: 'start',
            labels: {
              boxWidth: 20,
              padding: 10
            }
          },
          elements: {
            line: {
              tension: 0,
              borderWidth: 3
            }
          },
          scale: {
            ticks: {
              suggestedMin: 50
            }
          }
        }
      }
      if (this.objradarGraph) {
        this.objradarGraph.data = objChart.data
        this.objradarGraph.options = objChart.options
        this.objradarGraph.update()
      } else {
        this.objradarGraph = new ChartJS(document.getElementById('radarGraph'), objChart)
      }
    }
  },
  mounted () {
    const component = this
    this.getPoisGraphData()

    component.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      // window.addEventListener('resize', this.getWindowHeight)
      this.getWindowWidth()
      // this.getWindowHeight()
    })
  },
  components: {
    Card,
    Timeline,
    SocialCard,
    StatusCero,
    KpiDefault,
    AlertsAndCampaignList,
    Carousel,
    Slide,
    IconSvg,
    Chart,
    ChartModal
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
    window.removeEventListener('resize', this.getWindowHeight)
  },
  created () {
    this.init()
  }
}
</script>

<style lang='scss'>
.sc-dashboard{
  margin: rem(16) rem(16);
  @media only screen and (min-width: $--md){
    margin: 0 auto;
  }
  &__centralidad {
    .ods-scrollbar {
      height: 100%;
      .wrap-class-canvas {
        max-height: none !important;
      }
    }
  }
  &__alert, &__campanigns, &__social{
    height: 100%;
    /deep/ .sc-card__body{
      height: calc(100% - 60px);
      &-inner {
        height: calc(100% - 14px);
        > div {
          height: 100%;
          .ods-scrollbar__bar{
            &.is-vertical{
              padding: 0 rem(5);
              right: 0;
              background: $--color-white;
            }
            &.is-horizontal{
              padding: rem(5) 0;
              bottom: 0;
              background: $--color-white;
            }
          }
          .ods-scrollbar__view{
            margin-bottom: rem(16);
            height: 100%;
          }
        }
      }
    }
  }

  &__kpis {
    &__content {
      width: 100%;
    }
  }
  &__table{
    margin-top: rem(40);
  }
  &__row{
    height: 100%;
    // margin-bottom: 0;
  }
  .maxSizeCarousel .sc-dashboard__row{
    padding: 0 40px;
  }
  &__col{
    display: flex;
    flex-direction: column;
    @media only screen and (min-width: $--md){
      padding-bottom: 0;
    }
  }

  .sc-card{
    &--big, &--small{
      .sc-card__header {
        // height: calc(12% - 32px);
      }
      .sc-card__body{
        min-height: 0 !important;
        height: calc(84% - 1.5rem);
        &-inner {
          height: 100%;
          & > div {
            height: 100%;
          }
        }
      }
    }
    &__header__inner{
      border: 0;
    }
    .ods-tabs__content {
      height: 75%;
    }
    .ods-tab-pane{
      height: 100%;
    }
  }
  .sc-dashboard__social{
    #pane-first .ods-scrollbar{
      height: 100%;
      .ods-scrollbar__wrap {
        max-height: none;
      }
    }
    .ods-tabs__content {
      height: 100%;
    }
  }
  /deep/ .sc-card{
    &--big, &--small{
      .sc-card__body{
        padding: 0;
        &-inner {
          padding-bottom: rem(16);
        }
      }
    }
    &__header__inner{
      border: 0;
    }
  }

  /deep/ .ods-tabs__header{
    background: $--color-white;
    margin: 0 0 rem(24) 0;
    opacity: 1;
    top: 0;
    width: 100%;
    z-index: 3;

    padding: 0 rem(32);
    -webkit-box-shadow: -2px 9px 15px 0px rgba(219,219,219,0.2);
    -moz-box-shadow: -2px 9px 15px 0px rgba(219,219,219,0.2);
    box-shadow: -2px 9px 15px 0px rgba(219,219,219,0.2);
  }
  /deep/ .ods-tabs__content{
    height: calc(100% - 34px);
    padding: 0 rem(24);
  }
  /deep/ .ods-table__body-wrapper .ods-table__row:hover:last-child > td:after{
    display: none;
  }

  /deep/ .h100{
    height: 100%;
  }

  /deep/ .ods-table{
    // padding-top: rem(8);
    // padding-right: rem(16);
    // padding-bottom: rem(8);

    &__body{
      padding-bottom: rem(24);
    }
    &::before {
      height: 0;
    }
    .cell{
      word-break: initial;
      line-height: 1.4;
      padding: 0 rem(10);
    }
    tr:last-child() td{
      border-bottom: 0;
    }
    td{
      padding: rem(8) 0;
      .cell{
        align-items: center;
        display: flex;
        justify-content: start;
        min-height: rem(56);
      }
    }
  }

  /deep/ .ods-date-editor.ods-input {
    width: rem(120);
  }
  .card-opening-line{
    color: $--color-grey-dark;
    font-size: rem(10);
    font-weight: 500;
    line-height: rem(20);
    margin-bottom: rem(32);
    text-transform: uppercase;
  }

  .today-button{
    margin-left: rem(16);
  }

  .detail-icon{
    cursor: pointer;
  }

  .table-dot{
    margin-right: 13px;
  }

  /deep/ .ods-kpi--no-href, .ods-kpi--no-href {
    display: flex;
    height: 100%;
    .ods-kpi {
      &__list {
        min-height: rem(64);
        height: rem(75);
        width: 100%;
      }
      &__number {
        font-size: rem(32);
        max-height: rem(32);
        &+.kpi_title{
          color: $--color-neutral-1;
          margin: rem(8) 0;
        }
      }
    }
    .percentageNull {
      color: $--color-neutral-1;
      font-family: Soho;
      font-size: rem(12);
      font-weight: 500;
      letter-spacing: .4px;
      line-height: 1;
      margin-top: rem(8);
    }
    .kpi_circle{
      height: auto;
      line-height: rem(16);
      margin-bottom: rem(10);
      & > span {
        &:first-child{
          margin-right: 3px;
        }
        display: inline-block;
        line-height: 1;
        word-break: break-word;
        margin: 0;
      }
      .symbol {
        font-size: 1.025rem;
      }
    }
  }

  /deep/ .ods-kpi--default {
    .ods-kpi__number {
      font-size: rem(32);
      max-height: rem(32);
    }
  }

  .kpi-unit{
    color: $--color-black;
    font-family: 'Soho';
    font-size: rem(10);
    font-weight: 500;
    line-height: rem(16);
    text-align: left;
    text-transform: uppercase;
  }

  .VueCarousel-slide{
    max-width: 432px;
    & > div{
      cursor: pointer;
      background: $--color-white;
      border: 1px solid $--color-white;
      border-radius: rem(4);
      box-shadow: 0 2px rem(10) 0 rgba(0, 0, 0, 0.05) !important;
      height: calc(100% - 34px);
      margin: 0 rem(8);
      padding: rem(16);
      &:hover {
        border: 1px solid $--color-primary;
      }
      &.VueCarousel-slide-selected {
        border: 1px solid $--color-primary;
      }
    }
    button .ods-icon-arrow-right{
      font-size: rem(16);
      position: absolute;
      right: rem(10);
      top: rem(2);
    }
  }
  /deep/ .VueCarousel-navigation-button {
      border-radius: 50%;
      padding: rem(8);
      & > i{
        color: $--color-black;
        font-size: rem(20);
      }
  }

  /deep/ {
    .VueCarousel-navigation{
      &-prev {
        left: -5px;
      }
      &-next{
        right: -5px;
      }
    }
  }
  .maxSizeCarousel {
    background: $--color-primary-light-9;
    height: rem(136);
    padding: rem(16) 0 rem(70) 0;
  }
  .maxSizeRow2 {
    background: $--color-neutral-4;
    height: calc(100vh - 290px);
    padding: 0 rem(16);

    .sc-dashboard__col{
      margin-top: rem(-50);
      height: calc(100% + 50px);
    }
  }
  /deep/ .ods-scrollbar__wrap {
    max-height: calc(100vh - 358px) !important;
  }
  .maxSizeCard {
    min-width: rem(384);
    width: 100%;
  }
  .maxSizeSocialCard {
    padding-right: rem(16);
  }
  .ods-scrollbar {
    margin-right: -1px;
  }
  .filterKpiCarousel {
    margin: rem(16) 20% 0 20%;
    width: 50%;
    .ultimas7semanas, .selectedFilter {
      font-family: "Soho";
      font-weight: 500;
      text-transform: uppercase;
    }
    .ultimas7semanas {
      color: $--color-grey-dark;
      font-size: rem(10);
      line-height: rem(20);
    }
    .selectedFilter {
      color: $--color-neutral-1;
      font-size: rem(8);
      line-height: rem(16);
      margin: 0 0 rem(12);
    }
  }
  .ods-tabs {
    height: 100%;
    /deep/ &__content{
      height: 100%;
      .ods-tab-pane {
        height: 100%;
      }
    }
  }
  /deep/ .ods-tabs {
    height: 100%;
    /deep/ &__content{
      height: 100%;
      .ods-tab-pane {
        height: 100%;
      }
    }
  }

  // Carousel
  /deep/ .carouselKpis {
    margin: 0 auto;
    width: 94%;

    .icon-svg {
      g path{
        fill: $--color-neutral-1;
      }
    }

    @for $i from 1 through 9 {
      .VueCarousel-slide:nth-child(#{$i}) > div{
        transition: transform 0.4s $i * 0.2s;
      }
    }

  }
  /deep/ .sc-dashboard__carousel{
    background-color: transparent;
    .sc-card__body{
      height: auto;
      min-height: 0;
      .ods-loading-mask {
        background-color: transparent;
      }
    }
    &.sc-card--small .sc-card__body{
      height: auto;
      min-height: 0;
    }
  }
  /deep/ .selectFilterCarousel input {
    background: $--color-white;
  }

  .sc-kpi__title {
    margin-bottom: rem(8);
    .icon-svg{
      vertical-align: middle;
      margin-right: rem(8);
    }
  }
  span.sc-kpi__icon {
    position: absolute;
    right: rem(8);
    &--info{
      top: 0;
    }
    &--arrow{
      bottom: 0;
    }
  }
  .sc-dashboard__social .ods-select{
    width: rem(120);
  }
  /deep/ .sc-dashboard__social .ods-tabs__item{
    padding-top: rem(2);
    padding-bottom: rem(18);
  }
}
  /deep/ .ods-dialog.sc-modal {
    max-width: rem(720);
    .ods-dialog__body{
      padding: 0;
      margin-top: 0;
    }
    .sc-modal__body{
      align-items: center;
      display: flex;
      justify-content: center;
      .ods-row{
        width: 100%;
      }
    }
    .sc-card__body-inner{
      display: flex;
      height: rem(340);
      padding: 0;
    }
  }
.ods-dialog {
  .sc-modal {
    &__header {
      margin-bottom: rem(16);
    }
    &__meta {
      .ods-select {
        margin-right: rem(24);
      }
    }
    &__body {
      margin-top: rem(32);
    }
    &__procedure {
      margin-top: rem(32);
      padding-top: rem(16);
      width: 70%;
      .ods-input__inner {
        text-transform: capitalize;
      }
      p {
        margin-bottom: rem(24);
      }
      .sc-modal__title {
        font-size: rem(16);
        margin-bottom: rem(8);
      }
    }
  }
}
section.VueCarousel.carouselKpis {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue